
import React from "react";
import { Accordion, AccordionPanel, Panel } from '@ronuse/norseu/core/panels';
import Helpers from "../../../utils/Helpers";
import { Button } from "@ronuse/norseu/core/buttons";
import { InputText } from "@ronuse/norseu/core/form";
import { InputFilters } from "@ronuse/norseu/core/variables";

export class InputFiltersPage extends React.Component {

    constructor(props) {
        super(props);
        this.willUnmount = false;
        this.previewPanels = React.createRef();
        this.previewPanels.current = [];
    }

    componentWillUnmount() {
        this.willUnmount = true;
    }

    buildDocumentation() {
        return (
            <React.Fragment>
                <Panel borderless style={{ marginTop: 40 }}>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div className="norseu-display-flex sppai">
                                <div>
                                    <span>Alphabetic</span>
                                    <InputText filter={InputFilters.ALPHA} />
                                </div>
                                <div>
                                    <span>Alpha Numeric</span>
                                    <InputText filter={InputFilters.ALPHANUM} />
                                </div>
                                <div>
                                    <span>Positive Integers</span>
                                    <InputText filter={InputFilters.POSITIVE_INT} />
                                </div>
                                <div>
                                    <span>Integers</span>
                                    <InputText filter={InputFilters.INT} />
                                </div>
                                <div>
                                    <span>Positive Numbers</span>
                                    <InputText filter={InputFilters.POSITIVE_NUMBER} />
                                </div>
                                <div>
                                    <span>Numbers</span>
                                    <InputText filter={InputFilters.NUMBERS} />
                                </div>
                                <div>
                                    <span>Hexadecimals</span>
                                    <InputText filter={InputFilters.HEX} />
                                </div>
                                <div>
                                    <span>Email</span>
                                    <InputText filter={InputFilters.EMAIL} />
                                </div>
                                <div>
                                    <span>Money</span>
                                    <InputText filter={InputFilters.MONEY} />
                                </div>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
            </React.Fragment>
        );
    }

    render() {
        return Helpers.buildComponentPage(this, {
            title: "InputFilters",
            import_statement: "import { InputFilters } from '@ronuse/norseu/core/variables'",
            css_map: this.cssMap,
            documentation: this.buildDocumentation(),
            page_source: this.state.pageSource,
            show_dialog: this.state.showSourceDialog,
            source_url: "https://raw.githubusercontent.com/ronuse/norseu/main/showcase/src/components/core/form/InputFiltersPage.js"
        });
    }

    state = {
        pageSource: '',
        showSourceDialog: false
    };

    cssMap = [

    ];

    properties = [
        { name: "text", type: "string", default: "", description: "The label to show in the button" },
    ];
    
    refMap = [
        { name: "value()", type: "function", description: "Returns the value of the component internal HTML element" },
        { name: "setValue(value)", type: "function", description: "Set the value of the component internal HTML element" },
        { name: "focus()", type: "function", description: "Send focus to the component" },
        { name: "getInternalElement()", type: "function", description: "Get the react reference to the internal element" },
        { name: "getState()", type: "function", description: "Get the current state of the component" },
        { name: "setState(newState)", type: "function", description: "Change the component state" },
    ]

}